import { render, staticRenderFns } from "./renew-modal.vue?vue&type=template&id=0f0f52e0&lang=html&"
import script from "./renew-modal.vue?vue&type=script&lang=js&"
export * from "./renew-modal.vue?vue&type=script&lang=js&"
import style0 from "./renew-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports